module.exports = __webpack_public_path__ + "img/Delphinus_32@2x.2dbee4f6.png";